
export const FETCH_ALL_PRICE_LIST_REQUEST = 'FETCH_ALL_PRICE_LIST_REQUEST';
export const FETCH_ALL_PRICE_LIST_SUCCESS = 'FETCH_ALL_PRICE_LIST_SUCCESS';
export const FETCH_ALL_PRICE_LIST_FAILURE = 'FETCH_ALL_PRICE_LIST_FAILURE';


export const FETCH_BY_ID_PRICE_LIST_REQUEST = 'FETCH_BY_ID_PRICE_LIST_REQUEST';
export const FETCH_BY_ID_PRICE_LIST_SUCCESS = 'FETCH_BY_ID_PRICE_LIST_SUCCESS';
export const FETCH_BY_ID_PRICE_LIST_FAILURE = 'FETCH_BY_ID_PRICE_LIST_FAILURE';

export const CREATE_PRICE_LIST_REQUEST = 'CREATE_PRICE_LIST_REQUEST';
export const CREATE_PRICE_LIST_SUCCESS = 'CREATE_PRICE_LIST_SUCCESS';
export const CREATE_PRICE_LIST_FAILURE = 'CREATE_PRICE_LIST_FAILURE';

export const UPDATE_PRICE_LIST_REQUEST = 'UPDATE_PRICE_LIST_REQUEST';
export const UPDATE_PRICE_LIST_SUCCESS = 'UPDATE_PRICE_LIST_SUCCESS';
export const UPDATE_PRICE_LIST_FAILURE = 'UPDATE_PRICE_LIST_FAILURE';

export const DELETE_PRICE_LIST_REQUEST = 'DELETE_PRICE_LIST_REQUEST';
export const DELETE_PRICE_LIST_SUCCESS = 'DELETE_PRICE_LIST_SUCCESS';
export const DELETE_PRICE_LIST_FAILURE = 'DELETE_PRICE_LIST_FAILURE';

export const CREATE_USERFORM_PRICE_LIST = 'CREATE_USERFORM_PRICE_LIST';
export const RESET_PRICE_LIST_USERFORM = 'RESET_PRICE_LIST_USERFORM';